__turbopack_context__.v({
  "bgRoot": "BgBlurredText-module__1JOz_W__bgRoot",
  "content1Root": "BgBlurredText-module__1JOz_W__content1Root",
  "content2Root": "BgBlurredText-module__1JOz_W__content2Root",
});
